import React, { useContext, useState } from "react";
import { TenantListContext } from "../TenantListView";
import { Container, Dropdown } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import SearchData from "../../../../components/SearchComponent/SearchData";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import FilterIcon from "../../../../assets/images/icons/filter-icon.svg";
import AddIcon from "../../../../assets/images/pluse.svg";
import DataTable from "../../../../components/TableComponent/DataTable";
import Loader from "../../../../components/Loader/Loader";
import DropUpIcon from "../../../../assets/images/icons/dropup-icon.svg";
import DropDownIcon from "../../../../assets/images/icons/dropdown-icon.svg";
import RefreshIcon from "../../../../assets/images/refresh.svg";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";
import "./tenantList.css";

const TenantList = () => {
  const {
    onClickAddAdmin,
    tenantList,
    totalPages,
    onPageChange,
    currentPage,
    spinnerStatus,
    searchData,
    onChangeSearch,
    // setStatusFilter,
    // setSubscriptionFilter,
    subscriptionPlanList,
    showDropdown,
    // setShowDropdown,
    isStatusExpanded,
    setIsStatusExpanded,
    isSubscriptionExpanded,
    setIsSubscriptionExpanded,
    selectedSubscriptionId,
    setSelectedSubscriptionId,
    selectedStatusId,
    setSelectedStatusId,
    handleClearFilters,
    onClickFilterButton,
    handleToggle,
    setCurrentPage,
    goToTenantActivity,
    permissionAccess,
    getTenantList,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    isSuperAdmin,
  } = useContext(TenantListContext);
  // console.log("subscriptionPlanList", subscriptionPlanList);

  const header = [
    { title: ContentData.tenantPage.organisationName, prop: "name" },
    { title: ContentData.tenantPage.organisationEmail, prop: "email" },
    {
      title: ContentData.tenantPage.subscriptionPlan,
      prop: "subscriptionPlan",
    },
    { title: ContentData.tenantPage.creationDate, prop: "creationDate" },
    { title: ContentData.tenantPage.status, prop: "status" },
    { title: "", prop: "action" },
  ];

  const statuses = [
    { id: "A", name: "Active" },
    { id: "I", name: "Inactive" },
  ];

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="boldBreadCrums">
          {ContentData.tenantPage.pageTitle}
        </span>
      </div>
      {spinnerStatus && <Loader />}

      <Container className="tenantListContainer">
        <div className="pageTittles">{ContentData.tenantPage.pageTitle}</div>
        <div className="searchAddSection adminRole">
          <div className="searchSection">
            <SearchData
              placeholder={ContentData.tenantPage.searchData}
              value={searchData}
              onChange={onChangeSearch}
              type="text"
            />
          </div>
          <div className="plusRefreshDtat">
            {/* <div className="roleRefresh"> */}
            <Dropdown
              autoClose="outside"
              show={showDropdown}
              onToggle={handleToggle}
            >
              <Dropdown.Toggle
                variant="link"
                id="dropdown-basic"
                className="custom-dropdown-toggle"
              >
                <div className="tenantFilterIcon">
                  <img src={FilterIcon} alt="filter" />
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="tenant-dropdown-menu"
                style={{
                  backgroundColor: "#F7F8FA",
                  width: "258px",
                  marginTop: "34px",
                }}
              >
                {/* Filter Header with Clear All */}
                <Dropdown.Item className="dropdown-filter-clear">
                  <span className="filter-text">Filter</span>
                  <span className="clear-all" onClick={handleClearFilters}>
                    Clear All
                  </span>
                </Dropdown.Item>

                {/* Subscription Plan Filter */}
                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isSubscriptionExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsSubscriptionExpanded(!isSubscriptionExpanded);
                  }}
                >
                  Subscription Plan
                  <img
                    src={isSubscriptionExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>
                {isSubscriptionExpanded &&
                  subscriptionPlanList.map((plan) => (
                    <Dropdown.Item
                      className={`dropdownItem subscription-item ${
                        selectedSubscriptionId === plan._id ? "selected" : ""
                      }`}
                      key={plan._id}
                      onClick={(e) => {
                        e.stopPropagation();
                        const newSubscriptionId =
                          selectedSubscriptionId === plan._id ? "" : plan._id;
                        setSelectedSubscriptionId(newSubscriptionId);
                      }}
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      {`${plan.name} (${plan.billingCycle})`}
                    </Dropdown.Item>
                  ))}

                {/* Status Filter */}
                <Dropdown.Item
                  className={`firstItem dropdownItem ${
                    isStatusExpanded ? "expanded" : ""
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsStatusExpanded(!isStatusExpanded);
                  }}
                >
                  Status
                  <img
                    src={isStatusExpanded ? DropUpIcon : DropDownIcon}
                    alt="toggle"
                  />
                </Dropdown.Item>
                {isStatusExpanded &&
                  statuses.map((status) => (
                    <Dropdown.Item
                      className={`dropdownItem status-item ${
                        selectedStatusId === status.id ? "selected" : ""
                      }`}
                      key={status.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        const newStatusId =
                          selectedStatusId === status.id ? "" : status.id;
                        setSelectedStatusId(newStatusId);
                      }}
                      style={{
                        paddingLeft: "20px",
                      }}
                    >
                      {status.name}
                    </Dropdown.Item>
                  ))}

                {/* Apply Button */}
                <Dropdown.Item className="dropdownItem status-item tenantThemeBtn">
                  <ThemeButton
                    value={"Apply"}
                    className={""}
                    onClick={() => {
                      // setCurrentPage(1);
                      onClickFilterButton(
                        selectedSubscriptionId,
                        selectedStatusId
                      );
                    }}
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            {/* </div> */}
            {isSuperAdmin && (
              <div className="roleRefresh" onClick={() => goToTenantActivity()}>
                <img src={RefreshIcon} alt="refresh" />
              </div>
            )}
            <div
              className={`addAdmin ${
                permissionAccess?.add ? "" : "disabledMainButton"
              }`}
              onClick={onClickAddAdmin}
            >
              <img src={AddIcon} alt="add" />
              {ContentData.tenantPage.addTenant}
            </div>
          </div>
        </div>
        <div className="basicContainer roleListTable">
          <DataTable
            tableData={tenantList}
            header={header}
            onPageChange={(e) => onPageChange(e)}
            isPagination={true}
            currentPage={currentPage}
            pageCount={totalPages}
          />
        </div>
      </Container>
      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            goToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getTenantList();
          }
        }}
      />
    </div>
  );
};

export default TenantList;
